import { render, staticRenderFns } from "./MapaDepartamentos.vue?vue&type=template&id=d53a3ce8&"
import script from "./MapaDepartamentos.vue?vue&type=script&lang=js&"
export * from "./MapaDepartamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports